import { render, staticRenderFns } from "./SearchNormalText.vue?vue&type=template&id=49b0524c&scoped=true"
import script from "./SearchNormalText.vue?vue&type=script&lang=js"
export * from "./SearchNormalText.vue?vue&type=script&lang=js"
import style0 from "./SearchNormalText.vue?vue&type=style&index=0&id=49b0524c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b0524c",
  null
  
)

export default component.exports